import React, { useState } from "react";
import { Form, Select, Input, Empty } from "antd";
import { get } from "lodash";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerLib from "react-datepicker";
const RenderFilterFields = ({
  date,
  filtersData,
  onFieldChange,
  dateRangeError,
  setDateRangeError,
  dateRangeErrorMessage,
  setDateRangeErrorMessage,
}) => {
  const [filterDateRange, setFilterDateRange] = useState(moment(date).toDate());

  const handleChange = (value, filterCode, filterType) => {
    if (filterType === "multi_date_picker") {
      const date1 = get(value, "[0]", null);
      const date2 = get(value, "[1]", null);
      setFilterDateRange(value);
      onFieldChange("startDate", date1);
      onFieldChange("endDate", date2);
    } else if (filterType === 'date') {
      const date = moment(value).toDate();
      setFilterDateRange(date);
      onFieldChange("startDate", moment(date).format('YYYY-MM-DD'));
      onFieldChange("endDate", moment(date).format('YYYY-MM-DD'));
    } else {
      onFieldChange(filterCode, value);
    }
  };

  return filtersData.map((filter) => {
    switch (filter.filter_type) {
      case "code_name_spinner":
        return (
          <Form.Item
            key={filter.filter_code}
            label={filter.filter_title}
            name={filter.filter_code}
          >
            <Select
              allowClear
              mode={filter.is_single_select ? undefined : "multiple"}
              options={filter.filter_values
                ?.map((val) =>
                  val
                    ? { label: val.value, value: val.code, key: `${val.code}` }
                    : null
                )
                .filter(Boolean)}
              placeholder={`Select ${filter.filter_title}`}
              onChange={(value) =>
                handleChange(value, filter.filter_code, filter.filter_type)
              }
              style={{ minWidth: '200px' }}
              showSearch
              notFoundContent={
                filter.filter_values?.length ? null : (
                  <Empty description="No options available" />
                )
              }
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            />
          </Form.Item>
        );

      case "text":
        return (
          <Form.Item
            key={filter.filter_code}
            name={filter.filter_code}
            label={filter.filter_title}
          >
            <Input.Search
              placeholder={`Enter ${filter.filter_title}`}
              onChange={(e) =>
                handleChange(
                  e.target.value,
                  filter.filter_code,
                  filter.filter_type
                )
              }
            />
          </Form.Item>
        );

      // Will use in future
      // case "multi_date_picker":
      //   return (
      //     <Form.Item
      //       key={filter.filter_code}
      //       name={filter.filter_code}
      //       label={filter.filter_title}
      //       validateStatus={dateRangeError ? "error" : ""}
      //       help={dateRangeError ? dateRangeErrorMessage : ""}
      //     >
      //       <RangePicker
      //         placeholder={["Start Date", "End Date"]}
      //         format="YYYY-MM-DD"
      //         className="w-100"
      //         onChange={(dates, dateStrings) => {
      //           handleChange(
      //             dateStrings,
      //             filter.filter_code,
      //             filter.filter_type
      //           );
      //           setDateRangeError(false);
      //           setDateRangeErrorMessage("");
      //         }}
      //       />
      //     </Form.Item>
      //   );

      case "date":
        return (
          <Form.Item
            key={filter.filter_code}
            name={filter.filter_code}
            label={filter.filter_title}
            initialValue={moment().format("YYYY-MM-DD")}
            validateStatus={dateRangeError ? "error" : ""}
            help={dateRangeError ? dateRangeErrorMessage : ""}
          >
            <DatePickerLib
              selected={filterDateRange}
              onChange={value => handleChange(value, filter.filter_code, filter.filter_type)}
              className="px-4 py-2 react-calender-input"
              calendarIconClassname="mt-1"
              showIcon
              placeholderText="Select Date"
            />
          </Form.Item>
        );
      default:
        return null;
    }
  });
};

export default RenderFilterFields;
